import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const transformations = [{
  bad: 'Ponés la tablet y rezás',
  good: 'Creás el ambiente y esperás el avance'
}, {
  bad: 'El niño encuentra los límites de tu paciencia',
  good: 'Vos encontrás los límites de su sistema nervioso'
}, {
  bad: 'Cada cena genera ansiedad',
  good: 'Cada cena es un proceso con dirección'
}, {
  bad: 'Respondés a las crisis',
  good: 'Prevenís las crisis'
}, {
  bad: 'Trabajás con intuición agotada',
  good: 'Trabajás con un sistema probado'
}, {
  bad: 'El menú se restringe cada mes',
  good: 'El menú crece de a un alimento por vez'
}, {
  bad: 'La culpa te acompaña cada noche',
  good: 'El progreso te sostiene cada semana'
}];
export function TransformationTable() {
  return <section className="w-full py-20 md:py-24 px-4 bg-warm-cream" data-id="element-261">
      <div className="max-w-5xl mx-auto" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-heading" data-id="element-264">
            LO QUE CAMBIA EN TU FAMILIA
          </h2>
        </motion.div>

        {/* Desktop Table */}
        <div className="hidden md:block bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100" data-id="element-265">
          <div className="grid grid-cols-2" data-id="element-266">
            <div className="bg-light-coral p-6 text-center border-b border-r border-white" data-id="element-267">
              <h3 className="text-xl font-bold text-secondary-coral flex items-center justify-center" data-id="element-268">
                <XIcon className="w-6 h-6 mr-2" data-id="element-269" /> Sin el Método
              </h3>
            </div>
            <div className="bg-light-green p-6 text-center border-b border-white" data-id="element-270">
              <h3 className="text-xl font-bold text-primary-green flex items-center justify-center" data-id="element-271">
                <CheckIcon className="w-6 h-6 mr-2" data-id="element-272" /> Con el Método
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-273">
            {transformations.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="grid grid-cols-2 hover:bg-gray-50 transition-colors" data-id="element-274">
                <div className="p-5 flex items-center border-r border-gray-100" data-id="element-275">
                  <XIcon className="w-5 h-5 text-secondary-coral/50 mr-3 flex-shrink-0" data-id="element-276" />
                  <span className="text-lg text-text-body" data-id="element-277">{row.bad}</span>
                </div>
                <div className="p-5 flex items-center bg-light-green/10" data-id="element-278">
                  <CheckIcon className="w-5 h-5 text-primary-green mr-3 flex-shrink-0" data-id="element-279" />
                  <span className="text-lg font-medium text-text-heading" data-id="element-280">
                    {row.good}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-6" data-id="element-281">
          {transformations.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col" data-id="element-282">
              <div className="p-4 bg-light-coral/50 flex items-start border-b border-gray-100" data-id="element-283">
                <XIcon className="w-5 h-5 text-secondary-coral mr-3 mt-0.5 flex-shrink-0" data-id="element-284" />
                <span className="text-text-body" data-id="element-285">{row.bad}</span>
              </div>
              <div className="p-4 bg-light-green/30 flex items-start" data-id="element-286">
                <CheckIcon className="w-5 h-5 text-primary-green mr-3 mt-0.5 flex-shrink-0" data-id="element-287" />
                <span className="font-medium text-text-heading" data-id="element-288">
                  {row.good}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}